import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";

import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-partners-list',
  templateUrl: './partners-list.component.html',
  styleUrls: ['./partners-list.component.scss'],
      encapsulation: ViewEncapsulation.None
})
export class PartnersListComponent implements OnInit {

  public partners: any[] = [];
  previewUrl: string;
 
   constructor( 
     private apisService: ApisService,
       private toastr : ToastrService,
     // private loadingService: Loadingscr,
     private router: Router,
         private translate: TranslateService
   ) {} 
 
   public currentPage = 1; 
   public itemsPerPage = 10;
   public totalItems = 0;
   public messages: any = {};

   public tempData = [];
 
   @ViewChild(DatatableComponent) table: DatatableComponent;
 
   public ColumnMode = ColumnMode;
   public SelectionType = SelectionType;v
 
   ngOnInit(): void {
    this.getData() ;


        this.setDatatableMessages(); // set initial messages

    // listen for language change dynamically
    this.translate.onLangChange.subscribe(() => {
      this.setDatatableMessages();
    });

  }

   private setDatatableMessages() {
    this.messages = {
      totalMessage: this.translate.instant('MENU.DASHBOARD.total')
    };
  }
   getData(){
     this.apisService.partners().subscribe({ 
       next:(response:any)=> { 
         this.partners = response.data || [] ;
         console.log('response is' , this.partners)
       }, 
       error:(err)=> { 
         console.log('error in fetching', err)
       }
     })
   }
  onImageError(event) {
  event.target.src = 'assets/images/logo/12.png';
 }
  
 
   addCoupon() {
     this.router.navigate(["main/coupons/add-coupon"]);
   }
 
   
 
  
 
   filterUpdate(event) {
     const val = event.target.value.toLowerCase();
     this.partners = this.tempData.filter((d) =>
       d.code.toLowerCase().includes(val)
     );
     this.table.offset = 0;
   }
     
  //            getTags(){ 
  // this.apisService.investors().subscribe({
  //   next: (response: any) => {
  //     // The actual array is in response.data.data
  //     this.pages = response.data;  

  //     this.totalItems = this.pages.length;
  //     console.log("pages:", this.pages);
  //   },
  //   error: (error: any) => {
  //     console.log(error);
  //   }
  // }
    
  // )
 
      /*----------   products  ----------*/
 deletePartners(id:any){ 
  this.apisService.DeletePartners(id).subscribe({
    next: (response: any) => {
   this.toastr.success(
        this.translate.instant('MENU.DASHBOARD.DELETED_SUCCESSFULLY')
      );       this.getData();
    },
    error: (error: any) => {
      console.log(error);
  this.toastr.error(
        this.translate.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
      );    }
  }
    
  )
 } 

 confirmDelete(id: any) {
  Swal.fire({
    title: this.translate.instant('MENU.DASHBOARD.CONFIRM_DELETE_TITLE'),
    text: this.translate.instant('MENU.DASHBOARD.CONFIRM_DELETE_TEXT'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this.translate.instant('MENU.DASHBOARD.YES_DELETE'),
    cancelButtonText: this.translate.instant('MENU.DASHBOARD.CANCEL')
  }).then((result) => {
    if (result.isConfirmed) {
      this.deletePartners(id);
    }
  });
}

editPartners(id: number) {
  this.router.navigate(['/edit-partners',id]);
}

// removeCurrentLogo(): void {
//     this.partners = '';
//     // إعادة تعيين حقل الرفع
//     const fileInput = document.getElementById('logoUpload') as HTMLInputElement;
//     if (fileInput) fileInput.value = '';
// }



// confirmNewLogo(): void {
//     this.partner.logo = this.previewUrl;
//     this.previewUrl = '';
// }


}
